import { MainContainer } from "components/shared";
import { SettingLayout } from "layouts/SettingLayout";
import { InnerOptions } from "../InnerOptions";
import { Box } from "components/ui/Box";
import { UpdateForm } from "./UpdateForm";
import { useErrorHandler } from "exceptions/ErrorHandler";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { useHubChecklistUser } from "hooks/api";
import { InHomolog } from "utils/InHomolog";

export const HubUpdateChecklistUser: React.FC = () => {
  const { options } = InnerOptions();
  const { id } = useParams<{ id: string }>();
  const { errorHandler } = useErrorHandler();
  const { getChecklistUser } = useHubChecklistUser();

  const { data } = useQuery({
    queryKey: ["getChecklistUser", id],
    queryFn: () => getChecklistUser(id),
    enabled: !!id,
    onError: errorHandler,
  });

  return (
    <MainContainer>
      <InHomolog />
      <SettingLayout options={options}>
        <Box>
          <UpdateForm data={data} />
        </Box>
      </SettingLayout>
    </MainContainer>
  );
};
